import { TrashCalendarApiTrashCalendarDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTrashCalendarDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: TrashCalendarApiTrashCalendarDeleteRequest, config) =>
      appApiClient.trashCalendarApi.trashCalendarDelete(req, config),
  });
